import get from './get';
import deleteTeamMember from './deleteTeamMember';
import update from './update';
import storeTeamMember from './storeTeamMember';
import getRentals from './getRentals';
import fetch from './fetch';
import attachTeamMember from './attachTeamMember';

export default {
  get,
  deleteTeamMember,
  update,
  storeTeamMember,
  getRentals,
  fetch,
  attachTeamMember,
};



// WEBPACK FOOTER //
// ./src/app/services/team_member/index.js